<nav
  class="navbar navbar-expand fixed-top navbar-default"
  style="box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2)"
>
  <button class="navbar-toggler" type="button">
    <i class="fa-light fa-bars"></i>
  </button>
  <a class="navbar-brand">
    <picture>
      <source
        srcset="assets/img/icons/web-app-logo/logo-dark.svg"
        media="(prefers-color-scheme: dark)"
      />
      <img
        src="assets/img/icons/web-app-logo/logo-light.svg"
        alt="FixPlaner"
        width="40"
        height="40"
      />
    </picture>
    <img
      src="../../../../../assets/img/logo-text.svg"
      alt="FixPlaner"
      class="logo-text"
    />
  </a>
  <div
    [class.show]="!isMenuCollapsed"
    class="collapse navbar-collapse"
    id="navbarSupportedContent"
  >
    <ul
      *ngIf="!isRegisteredStepper"
      class="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll"
    ></ul>
    <ul class="nav navbar-nav">
      <li class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle"
          href="#"
          id="navbarDropdownMenuLink"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fa-light fa-language"></i> {{ lang }}
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <a
            class="dropdown-item"
            *ngFor="let l of languages"
            (click)="changeLocale(l.code)"
            href="javascript:void(0)"
            >{{ l.label }}</a
          >
        </div>
      </li>
    </ul>
  </div>
  <div class="d-none d-sm-none d-md-none d-lg-block d-xl-block ml-auto"></div>
  <li style="list-style-type: none" class="nav-item dropdown">
    <a
      style="width: 140px; text-align: right"
      class="nav-link dropdown-toggle"
      href="#"
      id="navbarDropdown"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <i class="fa-light fa-circle-user fa-xl"></i> {{ authService.firstName }}
    </a>
    <ul
      class="dropdown-menu"
      aria-labelledby="navbarDropdownMenuLink"
      style="width: 300px; white-space: nowrap"
    >
      <li>
        <a
          class="dropdown-item w-100"
          (click)="onLogoutClick()"
          href="javascript:void(0)"
          style="padding-left: 5px"
        >
          <i class="fa-light fa-right-from-bracket"></i> {{ "Logout" | translate }}
        </a>
      </li>
    </ul>
  </li>
  <div *ngIf="loading" class="progress-container">
    <xds-progress [indeterminate]="true"></xds-progress>
  </div>
</nav>
